import React, { lazy, useState, Suspense, useEffect } from 'react'
import './Coupon.css'
import { Layout, NotAllowed } from 'components'
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Container
} from 'reactstrap'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { userSelector } from 'features/auth/authSelectors'

const CouponList = lazy(() => import('./CouponList'))
const UserCouponList = lazy(() => import('../UserCoupon/UserCouponList'))

function Coupon(props) {
  const currentUser = useSelector(userSelector)

  const { search, pathname } = useLocation()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('list')

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
      navigate(`${pathname}?tab=${tab}`)
    }
  }

  useEffect(() => {
    const tabParam = new URLSearchParams(search).get('tab')
    let initialTab = tabParam || 'list'

    if (props.sub) initialTab = 'list'
    setActiveTab(initialTab)
  }, [])

  const { isRoot, previleges } = currentUser

  const children = (
    <>

      <Container className='page-content' fluid style={{ padding: 30 }}>
        <Row>
          <Nav tabs>
            {[
              { tab: 'list', label: '쿠폰' },
              { tab: 'history', label: '쿠폰내역' },
            ].map(({ tab, label }) => (
              <NavItem key={tab}>
                <NavLink
                  className={activeTab === tab ? 'sub-link active' : ''}
                  onClick={() => toggleTab(tab)}
                >
                  {label}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Row>
        <Row>
          <TabContent activeTab={activeTab}>
            {[
              { tab: 'list', component: <CouponList /> },
              { tab: 'history', component: <UserCouponList /> },
            ].map(({ tab, component }) => (
              <TabPane key={tab} tabId={tab}>
                {activeTab === tab && ( 
                  <Suspense fallback={<div>Loading...</div>}>
                    {component}
                  </Suspense>
                )}
              </TabPane>
            ))}
          </TabContent>
        </Row>
      </Container>
    </>
  )
  if (props.sub) {
    return children
  }

  return <Layout>{children}</Layout>
}

export default Coupon
